// Routes/AdminProtectedRoute.jsx
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import { CircularProgress, Box } from '@mui/material';

const AdminProtectedRoute = ({ children }) => {
  const { isAuthenticated, authLoading, checkAuth } = useAdminAuth();

  useEffect(() => {
    // Only check auth when loading protected route
    if (!isAuthenticated && !authLoading) {
      checkAuth().catch(() => {
        // Silent fail - will redirect below
      });
    }
  }, [isAuthenticated, authLoading, checkAuth]);

  if (authLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export default AdminProtectedRoute;